
import useWindowWidth from 'hooks/use-window-width'
import React, { useEffect, useRef } from 'react'

export const FloatingTrustpilotContainer = () => {
    const ref = useRef<HTMLDivElement>(null)
    const width = useWindowWidth()

    const data = {
        'data-locale': "en-US",
        'data-template-id': '53aa8807dec7e10d38f59f32',
        'data-businessunit-id': '5fa44c2c9262500001e6a79a',
        'data-style-height': '40',
        'data-style-width': '100',
        'data-theme': 'dark',
    }

    const dataMobile = {
        'data-locale': "en-US",
        'data-template-id': '53aa8807dec7e10d38f59f32',
        'data-businessunit-id': '5fa44c2c9262500001e6a79a',
        'data-style-height': '58',
        'data-style-width': '145',
        'data-theme': 'dark',
    }

    useEffect(() => {
        if (typeof window === 'undefined' || !ref.current || !window?.Trustpilot || !width) return

        window.Trustpilot?.loadFromElement(ref.current)
    }, [width])

    return (
        <div
            id="floating-trustpilot"
            ref={ref}
            className="trustpilot-widget"
            style={{ display: 'none', height: '0' }}
            {...(width <= 600 ? dataMobile : data)}
        >
            <a href="https://www.trustpilot.com/review/coinrabbit.io"
                target="_blank" 
                rel="noopener noreferrer"></a>
        </div>
    )
}